import AnalyticsAlarmsWidget from './component'

export default AnalyticsAlarmsWidget
